import { api, LightningElement, wire } from "lwc";

import { assignedSlotNames } from "common/slot";
import { createTrack, TrackEvent } from "common/track";

import type { App } from "tds/appLauncher";
import type { Config } from "tds/header";
import type { NavItem } from "tds/headerNav";
import type { UserProfile } from "tds/headerProfile";

import { ResizeAdapter, ResizeAdapterConfig } from "common/resizeAdapter";

export default class extends LightningElement {
  @api apps: App[] | null = null;
  @api help: Config["help"] | null = null;
  @api labels: { [key: string]: string } = {};
  @api logo: Config["logo"] | null = null;
  @api navItems: NavItem[] | null = null;
  @api user: UserProfile | null = null;
  @api signinLink: Config["signinLink"] | null = null;
  @api signupLink: Config["signupLink"] | null = null;
  @api skipLink: Config["skipLink"] | null = null;
  @api inboxNotification: Config["inboxNotification"];

  private isNavOverflowed = false;
  private slots = "";
  private track = createTrack<"tds-header-desktop">(this);

  private onSlotChange() {
    this.slots = assignedSlotNames(this.template).join(" ");
  }

  private handleAppLauncherTrack(e: TrackEvent<"tds-app-launcher">) {
    let eventName = e.detail.eventName;
    let name: `app_launcher_${typeof eventName}` = `app_launcher_${eventName}`;
    this.track(name, e.detail.payload);
  }

  private handleHelpButtonClick() {
    this.track("help_clicked", undefined);
  }

  private handleLogoClick() {
    this.track("logo_clicked", undefined);
  }

  private handleNavTrack(e: TrackEvent<"tds-header-nav">) {
    let eventName = e.detail.eventName;
    let name: `nav_${typeof eventName}` = `nav_${eventName}`;
    this.track(name, e.detail.payload);
  }

  private handleProfileTrack(e: TrackEvent<"tds-header-profile">) {
    let eventName = e.detail.eventName;
    let name: `profile_${typeof eventName}` = `profile_${eventName}`;
    this.track(name, e.detail.payload);
  }

  private handleSigninClick() {
    this.track("signin_clicked", { label: this.labels.logIn });
  }

  private handleSignupClick() {
    this.track("signup_clicked", { label: this.labels.signUp });
  }

  private handleInboxNotificationClick() {
    this.track("community_inbox_clicked", { label: this.labels.messages });
  }

  @wire<ResizeAdapterConfig>(ResizeAdapter)
  private onResize() {
    let $header = this.template.querySelector("header");
    let $nav = this.template.querySelector(".slot--nav");
    if ($header && $nav) {
      let isNavOverflowed = $nav.scrollWidth > $nav.offsetWidth;
      if (isNavOverflowed !== this.isNavOverflowed) {
        this.isNavOverflowed = isNavOverflowed;
        this.dispatchEvent(
          new CustomEvent("navoverflow", {
            detail: {
              overflow: isNavOverflowed,
              minWidth:
                $header.offsetWidth + ($nav.scrollWidth - $nav.offsetWidth),
            },
          })
        );
      }
    }
  }
}
